import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 48,
    lineHeight: 1,
    letterSpacing: 0,
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: 'Raleway',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.3,
    letterSpacing: 0,
    textAlign: 'center',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    borderRadius: 12,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  cardIcon: {
    width: 28,
    height: 28,
  },
  cardTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  cardText: {
    flexGrow: 1,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  cardButton: {
    height: 48,
    fontWeight: 600,
    letterSpacing: '0.04em',
    borderRadius: 8,
    textTransform: 'uppercase',
  },
  daiButton: {
    backgroundColor: theme.palette.primary.newAuth,
    color: theme.palette.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  manualButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
}))

export default useStyles
